<template>
  <div class="allTabs mt-10">
    <v-row dense>
      <v-col cols="7" sm="9" md="8">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
          hide-details class="input-search"></v-text-field>
      </v-col>
      <v-col cols="5" sm="3" md="2">
        <v-select solo :items="slots" append-icon="mdi-chevron-down" label="Buy / Sale All"
          class="custom-select"></v-select>
      </v-col>
      <v-col cols="5" sm="3" md="2">
        <v-select solo :items="slots2" append-icon="mdi-chevron-down" label="All Pair" class="custom-select"></v-select>
      </v-col>
    </v-row>
    <v-row dense class="mt-2">
      <v-col md="6" sm="6" lg="4" v-for="card in cards" :key="card.id">
        <v-card class="elevation-0 rounded-0 live-account-card signal-card"
          :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <v-card-actions class="top-section">
            <div class="amount">
              <v-icon :color="card.colorIcon">mdi mdi-circle-small</v-icon>
              <p class="mb-0">{{ card.currency }}<span :class="card.textColor">{{ card.actions }}</span></p>
            </div>
            <div class="targeted">
              <p class="mb-0">Target: <span>{{ card.targetAmount }}</span></p>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="100%" height="85px" type="line" :options="options" :series="series">
                </apexChart>
              </div>
            </v-sheet>
          </v-card-actions>
          <v-card-actions class="timing-section">
            <div class="trading-time">
              <p class="mb-0">Trading: <span>{{ card.tradingHour }}</span></p>
            </div>
            <div class="trading-time">
              <p class="mb-0">In: <span>{{ card.inTime }}</span></p>
            </div>
          </v-card-actions>
          <v-card-actions class="wrapper">
            <div class="user-profile-section">
              <div class="user">
                <v-avatar size="15">
                  <img src="../../../assets/avatar.png" alt="John" />
                </v-avatar>
                <span>{{ card.userName }}</span>
              </div>
              <div class="copies">
                <span>Copiers: {{ card.copier }}</span>
              </div>
            </div>
            <div class="profit">
              <p class="mb-0">Profit: <span>{{ card.profit }}</span></p>
            </div>
          </v-card-actions>
          <v-card-actions class="trading-success">
            <p class="mb-0">Trading Days: <span>{{ card.tradingDays }}</span></p>
            <p class="mb-0">Success: <span>{{ card.success }}</span></p>
          </v-card-actions>
          <v-card-actions class="pb-0 pt-3">
            <v-btn tile outlined elevation="0" @click="changeCopyText" class="text-capitalize btn-account mr-2 ml-n1"
              color="greenMain">{{ CopyText }}</v-btn>
            <v-btn tile @click="changeFollowText" elevation="0" class="text-capitalize btn-account ml-0"
              color="greenMain">{{ FollowText }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      CopyText: "Copy",
      FollowText: "Follow",
      search: "",
      slots: ["Buy", "Sale", "All"],
      slots2: ["USD", "INR", "JPY"],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
      cards: [
        {
          id: 1,
          currency: "EUR USD",
          actions: "Buy",
          targetAmount: "1.3892",
          tradingHour: "3h 15m",
          inTime: "39h 32m",
          userName: "Forex Bull",
          copier: "21",
          profit: "91%",
          tradingDays: "84",
          success: "78%",
          colorIcon: "#039de9",
        },
        {
          id: 2,
          currency: "EUR USD",
          actions: "Sale",
          targetAmount: "1.3892",
          tradingHour: "3h 15m",
          inTime: "39h 32m",
          userName: "Forex Bull",
          copier: "21",
          profit: "91%",
          tradingDays: "84",
          success: "78%",
          textColor: "text-red",
          colorIcon: "#FF567F",
        },
        {
          id: 3,
          currency: "EUR USD",
          actions: "Buy",
          targetAmount: "1.3892",
          tradingHour: "3h 15m",
          inTime: "39h 32m",
          userName: "Forex Bull",
          copier: "21",
          profit: "91%",
          tradingDays: "84",
          success: "78%",
          colorIcon: "#039de9",
        },
        {
          id: 4,
          currency: "EUR USD",
          actions: "Sale",
          targetAmount: "1.3892",
          tradingHour: "3h 15m",
          inTime: "39h 32m",
          userName: "Forex Bull",
          copier: "21",
          profit: "91%",
          tradingDays: "84",
          success: "78%",
          textColor: "text-red",
          colorIcon: "#FF567F",
        },
        {
          id: 5,
          currency: "EUR USD",
          actions: "Buy",
          targetAmount: "1.3892",
          tradingHour: "3h 15m",
          inTime: "39h 32m",
          userName: "Forex Bull",
          copier: "21",
          profit: "91%",
          tradingDays: "84",
          success: "78%",
          colorIcon: "#039de9",
        },
        {
          id: 6,
          currency: "EUR USD",
          actions: "Sale",
          targetAmount: "1.3892",
          tradingHour: "3h 15m",
          inTime: "39h 32m",
          userName: "Forex Bull",
          copier: "21",
          profit: "91%",
          tradingDays: "84",
          success: "78%",
          textColor: "text-red",
          colorIcon: "#FF567F",
        },
      ],
    };
  },
  methods: {
    changeCopyText() {
      this.CopyText = "Copied";
    },
    changeFollowText() {
      this.FollowText = "Followed";
    },
  },
};
</script>
